import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://pbnsnrloxnyhmksyzlpe.supabase.co";

// Google OAuth is configured in the Supabase dashboard with the following credentials:
// Client ID: 582622607305-re837iop3mc45lfa222otvokkgefu467.apps.googleusercontent.com
// Callback URL: https://pbnsnrloxnyhmksyzlpe.supabase.co/auth/v1/callback

const supabaseClient = createClient(
  supabaseUrl,
  process.env.REACT_APP_SUPABASE_KEY || "public-anon-key"
);

export default supabaseClient;
